export default __webpack_public_path__ + "static/media/Slide-3.e69451c7.jpg";